import selectOperatorBusinessModel from "@/components/mixins/select-operator-business-model"

export default {
	mixins: [selectOperatorBusinessModel],
	data() {
		return {
			moduleName: 'users',
			userUpdateFields: ['id', 'name', 'login', 'email', 'phone', 'id_role_group', 'roles_override'],
			entity: {
				password: '',
				id_role_group: null,
				roles_override: {},
			},
			operators: [],
			roleGroups: [],
			selectedFile: null,
			passwordChanged: false,
			newPassword: null,
			edit_allowed_section_list: [],
		}
	},
	computed: {
		isOperatorRole(){
			return this.$store.getters.getUserRole == 'ROLE_OPERATOR' || this.$_loggedUser_canChangeOperator;
		},
		requiredFields() {
			return [
				{'key': 'name', 'name': this.$gettext('příjmení')},
				{'key': 'login', 'name': this.$gettext('login'), 'ref': 'realloginref'},
				{'key': 'password', 'name': this.$gettext('heslo'), 'ref': 'realpasswordref'},
				{'key': 'email', 'name': this.$gettext('email'), 'ref': 'useremail'},
			]
		},
		password: {
			get() {
				if (this.entity.password && this.passwordChanged === false) {
					return '********'
				} else {
					if (this.entity.password === false) {
						return ''
					} else {
						return this.entity.password
					}
				}
			},
			set(value) {
				this.passwordChanged = true
				if (value === '') {
					this.newPassword = false
					this.entity.password = false
				} else {
					this.newPassword = value
					this.entity.password = value
				}
			}
		},
		operatorOptions() {
			if (this.operators) {
				return this._.map(this.operators, function (item) {
					return {id: item['id'], text: item['name']}
				})
			}
		},
		userInitials() {
			let initials = ''
			if (this.entity.name) {
				let words = this._.words(this.entity.name)
				initials = words[0].charAt(0)
				if (words.length > 1) {
					initials += words[1].charAt(0)
				}
			}
			return this._.toUpper(initials)
		},
	},
	methods: {
		saveLastVisited(userId) {
			this.setUserSetting('last-visited', userId)
		},
		onFileChange(e) {
			this.selectedFile = e.target.files[0]
		},
		getOperator() {
			this.setLoadingMessage()
			this.operatorService.getOperators()
				.then(data => {
					this.operators = data.operators
					this.emptyMessage()
				})
				.catch(error => {
					this.setErrorMessage(error['error_message'])
				})
		},
		getRoleGroupsSimpleList(){
			this.setLoadingMessage();
				this.roleGroupsService.getSimpleList()
					.then(data => {
						if(this.$_loggedUser_action_allowed('roleGroups', 'update')) {
							this.roleGroups = data.roleGroups;
							this.roleGroups.unshift({id: null, text: this.$gettext('Vyberte skupinu oprávnění')})
						}else{
							this.roleGroups = data.roleGroups.filter(obj => {
								return obj.code === 'ROLE_OPERATOR' || obj.code === 'ROLE_READ_ONLY' || obj.code === 'ROLE_SUPPORT';
							});
							this.entity.id_role_group = this.roleGroups[0].id;
						}
						this.emptyMessage();
					})
					.catch(error => {
						this.setErrorMessage(error['error_message'])
					})

		},
		getEditAllowedSectionList(){
			this.setLoadingMessage();
			if(this.$_loggedUser_action_allowed('roleGroups', 'update')) {
				this.roleGroupsService.getEditAllowedSectionList()
					.then(data => {
						this.edit_allowed_section_list = Object.values(data.edit_allowed_section_list);
						this.emptyMessage();
					}).catch(error => {
					this.setErrorMessage(error['error_message'])
				})
			}
		},
		onPasswordFocus() {
			if (!this.passwordChanged) {
				this.passwordProxy = this.entity.password
				this.entity.password = false
			}
		},
		onPasswordBlur() {
			if (!this.passwordChanged) {
				this.entity.password = this.passwordProxy
				this.passwordProxy = null
			}
		},
		resetPassword() {
			this.passwordChanged = false
			this.passwordProxy = null
		},
		uploadImage(userId) {
			if (this.selectedFile !== null) {
				const formData = new FormData()
				formData.append('uploaded_file', this.selectedFile)

				return this.userService.uploadEntityImage(userId, formData)
					.then(() => {
						this.selectedFile = null
					})
			}
		},
		filterUserParams(params) {
			let allowed = {}
			this._.forOwn(params, function (value, key) {
				if (this.userUpdateFields.includes(key)) {
					allowed[key] = value
				}

				if (this.newPassword !== null) {
					allowed['password'] = this.newPassword
				}
			}.bind(this))
			return allowed
		},
		processErrorMessage(error) {
			this.validateRequiredFields()

			// `error` object from ApiService._handle does not contain useful information from response :(

			if(error.error_message === 'Email must be valid.') {
				this.$refs['useremail'].setForcedInvalid(true, this.$gettext('Email není validní.'));
			}

			let loginError = null
			this._.forEach(error['validation_errors'], function (errorMessage) {
				if (errorMessage === "User login must be set.") {
					loginError = this.$gettext("Zadejte login")

				}
				if (errorMessage === "Given user's login already exists.") {
					loginError = this.$gettext("Zadaný login se již používá")
				}
			}.bind(this))

			if (!this.entity.login || loginError !== null) {
				this.setLoginInvalid(true, loginError)
			} else {
				this.setLoginInvalid(false)
			}

			return error['error_message']
		},
		setLoginInvalid(value = false, text = null) {
			this.$refs['realloginref'].setForcedInvalid(value, text)
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/views/users/mixins/users.js